import { render, staticRenderFns } from "./CriticaDespesaList.vue?vue&type=template&id=4e13734a&scoped=true"
import script from "./CriticaDespesaList.vue?vue&type=script&lang=js"
export * from "./CriticaDespesaList.vue?vue&type=script&lang=js"
import style0 from "./CriticaDespesaList.vue?vue&type=style&index=0&id=4e13734a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e13734a",
  null
  
)

export default component.exports